import "./index.less";
import { createPortal } from "react-dom";

export interface IChoosePopProps {
  title: string;
  options: {
    label: string;
    action: () => void;
  }[];
  visible: boolean;
}

const MobileChoosePop: React.FC<IChoosePopProps> = ({
  title,
  options,
  visible,
}) => {

  const getRight = (index: number) => {
    if(options.length <= 1) return 0;
    const allWidth = 80;
    const itemWidth = allWidth / options.length;
    console.log((10 + itemWidth * (index + 1)));
    return (10 + itemWidth * (index + 1));
  }

  if (!visible) return null;

  return createPortal(
    <div className="choose-pop">
      <div className="options-content bg-#fff rounded-4">
        <div className="font-600 lh-6 text-#333 text-3.75 mb-8 mt-8 ml-6 mr-6 w-68 text-wrap text-center">
          {title}
        </div>
        <div className="w-full h-0.25 bg-#E5E5E5"></div>
        <div className="flex h-13">
          {options.map((item, index) => {
            return (
              <div
                key={index}
                className="flex-1 flex items-center justify-center"
              >
                <div
                  onClick={item.action}
                  className="options-item flex justify-center items-center font-500 text-#000"
                >
                  {item.label}
                </div>
                {index !== options.length - 1 && (
                  <div className="h-13 w-0.25 bg-#E5E5E5 absolute" style={{ right: `${getRight(index)}%` }}></div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default MobileChoosePop;
